// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dual-in-matches {
  min-width: 1040px;
  width: 100%;
  height: 100vh;
}
  
  .dual-in-matches .CopyButton, .dual-in-matches .PhoneButton {
    display: inline;
    position: relative;
    left: 4px;
    opacity: 0;
    transition: opacity .2s ease-in-out;
  }
  
  .dual-in-matches td:hover .CopyButton, .dual-in-matches *:hover > .CopyButton, .dual-in-matches *:hover > .PhoneButton, .dual-in-matches td:hover .PhoneButton  {
    opacity: 1;
  }
  
  .dual-in-matches-spinner {
    position: absolute;
    right: 45%;
    bottom: 50%;
    width: 100px;
    height: 100px;
  }
  
  .dual-in-matches__header {
    display: flex;
    flex-direction: row;
    align-items: flex-end;
  }
  
  .dual-in-matches__header-text {
      font-size: 30px;
      line-height: 40px;
      font-weight: bold;
      margin-right: 20px;
    }
  
  .dual-in-matches__header div:nth-child(2) {
      width: 300px;
      margin-bottom: 10px;
    }
  
  .dual-in-matches__header div:nth-child(2) input {
        width: 300px;
      }
  
  .dual-in-matches__link-text {
    color: var(--color-blue-3);
  }
  
  .dual-in-matches__selectedLeg {
    margin-top: 20px;
  }
  
  .dual-in-matches__selectedLeg td {
      border: 1px solid var(--color-gray-3);
      padding: 10px 25px;
    }
  
  .dual-in-matches__selectedLeg td h3 {
        margin: 0;
      }
  
  .dual-in-matches__matches {
    width: 100%;
    margin-top: 34px;
    display: inline-block;
    margin-bottom: 20px;
  }
  
  .dual-in-matches__matches th {
      text-align: left;
      padding: 0 5px;
      cursor: pointer;
    }
  
  .dual-in-matches__matches td {
      padding: 5px;
    }
  
  .dual-in-matches__matches--red {
      color: var(--color-red-3);
    }

.right-sidebar-navigation__content-open {
  background: white;
  box-shadow: 0 2px 2px 0 #bbbcbd;
  padding: 20px;
  height: 100%;
  overflow-y: scroll;
}`, "",{"version":3,"sources":["webpack://./app/_blessed/components/features/Admin/features/ReactiveDualTrans/features/DualInMatches/style.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,WAAW;EACX,aAAa;AAiFf;;EA/EE;IACE,eAAe;IACf,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,mCAAmC;EACrC;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,qBAAqB;EAiBvB;;EAfE;MACE,eAAe;MACf,iBAAiB;MACjB,iBAAiB;MACjB,kBAAkB;IACpB;;EAEA;MACE,YAAY;MACZ,mBAAmB;IAKrB;;EAHE;QACE,YAAY;MACd;;EAIJ;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;EAUlB;;EARE;MACE,qCAAqC;MACrC,kBAAkB;IAKpB;;EAHE;QACE,SAAS;MACX;;EAIJ;IACE,WAAW;IACX,gBAAgB;IAChB,qBAAqB;IACrB,mBAAmB;EAerB;;EAbE;MACE,gBAAgB;MAChB,cAAc;MACd,eAAe;IACjB;;EAEA;MACE,YAAY;IACd;;EAEA;MACE,yBAAyB;IAC3B;;AAIJ;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,aAAa;EACb,YAAY;EACZ,kBAAkB;AACpB","sourcesContent":[".dual-in-matches {\n  min-width: 1040px;\n  width: 100%;\n  height: 100vh;\n  \n  .CopyButton, .PhoneButton {\n    display: inline;\n    position: relative;\n    left: 4px;\n    opacity: 0;\n    transition: opacity .2s ease-in-out;\n  }\n\n  td:hover .CopyButton, *:hover > .CopyButton, *:hover > .PhoneButton, td:hover .PhoneButton  {\n    opacity: 1;\n  }\n\n  &-spinner {\n    position: absolute;\n    right: 45%;\n    bottom: 50%;\n    width: 100px;\n    height: 100px;\n  }\n\n  &__header {\n    display: flex;\n    flex-direction: row;\n    align-items: flex-end;\n\n    &-text {\n      font-size: 30px;\n      line-height: 40px;\n      font-weight: bold;\n      margin-right: 20px;\n    }\n\n    & div:nth-child(2) {\n      width: 300px;\n      margin-bottom: 10px;\n\n      input {\n        width: 300px;\n      }\n    }\n  }\n\n  &__link-text {\n    color: var(--color-blue-3);\n  }\n\n  &__selectedLeg {\n    margin-top: 20px;\n\n    td {\n      border: 1px solid var(--color-gray-3);\n      padding: 10px 25px;\n\n      h3 {\n        margin: 0;\n      }\n    }\n  }\n\n  &__matches {\n    width: 100%;\n    margin-top: 34px;\n    display: inline-block;\n    margin-bottom: 20px;\n\n    th {\n      text-align: left;\n      padding: 0 5px;\n      cursor: pointer;\n    }\n\n    td {\n      padding: 5px;\n    }\n\n    &--red {\n      color: var(--color-red-3);\n    }\n  }\n}\n\n.right-sidebar-navigation__content-open {\n  background: white;\n  box-shadow: 0 2px 2px 0 #bbbcbd;\n  padding: 20px;\n  height: 100%;\n  overflow-y: scroll;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
